/**
 * TTS voice selection - maps male/female preference to voice index.
 * iOS: AVSpeechSynthesisVoice (Alex, Daniel = male; Samantha, Karen = female).
 * Android: android.speech.tts.Voice (similar name matching).
 */
import { TextToSpeech } from '@capacitor-community/text-to-speech';
import { Capacitor } from '@capacitor/core';

let cachedVoices: { name: string; lang: string }[] | null = null;

export async function getTTSVoiceIndex(
  preference: 'male' | 'female',
  lang = 'en-US'
): Promise<number | undefined> {
  if (!Capacitor.isNativePlatform()) {
    return undefined;
  }
  try {
    if (!cachedVoices) {
      const { voices } = await TextToSpeech.getSupportedVoices();
      cachedVoices = voices.map((v: { name: string; lang: string }) => ({
        name: v.name,
        lang: v.lang,
      }));
    }
    const maleNames = ['alex', 'daniel', 'fred', 'oliver', 'aaron', 'evan', 'nicky', 'eddy', 'male', 'en-us-male'];
    const femaleNames = ['samantha', 'karen', 'victoria', 'moira', 'kate', 'tessa', 'veena', 'female', 'en-us-female'];
    const targetNames = preference === 'male' ? maleNames : femaleNames;
    const langPrefix = lang.split('-')[0];
    const idx = cachedVoices.findIndex(
      (v) =>
        v.lang.toLowerCase().startsWith(langPrefix) &&
        targetNames.some((n) => v.name.toLowerCase().includes(n))
    );
    return idx >= 0 ? idx : undefined;
  } catch {
    return undefined;
  }
}
